exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".agreeTermsAndConditionsOfUseCheckbox__link___2s9QN {\n  color: #f94144; }\n", ""]);

// exports
exports.locals = {
	"link": "agreeTermsAndConditionsOfUseCheckbox__link___2s9QN"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"sourceMap":false,"minimize":true,"importLoaders":2,"localIdentName":"[name]__[local]___[hash:base64:5]"}!./node_modules/sass-loader/lib/loader.js?{"includePaths":["./src"]}!./src/containers/AdDetailsPage/AdDetailsPageMobile/EmailDealerModal/EmailDealerForm/AgreementSection/AgreeTermsAndConditionsOfUseCheckbox/agreeTermsAndConditionsOfUseCheckbox.scss
// module id = 4533
// module chunks = 6